import effect from '@/views/product/views/effect/effect'
export default effect;